import request from '@/utils/request'
// 获取提问列表
const getQuestionList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/question/list`,
        method: 'get',
        params
    })
}
// 获取提问列表数量
const getQuestionCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/question/count`,
        method: 'get',
        params
    })
}
// 修改提问状态
const editQuestionStatus = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/question`,
        method: 'put',
        params
    })
}
// 增加提问
const addQuestion = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/question`,
        method: 'post',
        data: params
    })
}
// 获取我的提问
const getMyQuestion = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/question/myQuestions`,
        method: 'get',
        params
    })
}
// 问题标记
const markQuestion = (meetingId, id, params) => {
    return request({
        url: `/gathering/meeting/${meetingId}/question/${id}`,
        data: params,
        method: 'put'
    })
}
export {
    getQuestionList,
    getQuestionCount,
    editQuestionStatus,
    addQuestion,
    getMyQuestion,
    markQuestion
}